import axios, { AxiosResponse } from 'axios'
import { PopulationParam } from 'common/constants/PopulationParam'
import { LayoutPromiseType } from 'common/types/LayoutPromiseType'
import { PagePromiseType } from 'common/types/PagePromiseType'
import Env from 'Env'
import HTTPMethod from 'http-method-enum'
import { AppInfoModel } from 'models/config/AppInfoModel'
import { Converters } from './Converters'
import { LayoutPromise } from './LayoutPromise'

class PagePromiseClass implements PagePromiseType {
  Layout: LayoutPromiseType
  constructor(layout: LayoutPromiseType) {
    this.Layout = layout
  }

  async GetFaqPage(isPreview?: boolean) {
    return this.GetPageBySlug('faq', isPreview)
  }

  async GetPageBySlug(slug: string, isPreview?: boolean) {
    const pageId = await this._getPageIdFromSlug(slug, isPreview)
    return this._getPageById(pageId, isPreview)
  }

  async GetHomePage(isPreview?: boolean) {
    const config = await this._getAppInfo()
    const homeSlug = this._getIndexPageSlug(config)

    return this.GetPageBySlug(homeSlug, isPreview)
  }

  GetPageWithHeaderFooter(slug: string, isPreview?: boolean) {
    return [this.Layout.MainMenu(), this.GetPageBySlug(slug, isPreview), this.Layout.FooterMenu(), this.Layout.Posters()]
  }

  GetHomePageWithHeaderFooter(isPreview?: boolean) {
    return [this.Layout.MainMenu(), this.GetHomePage(isPreview), this.Layout.FooterMenu(), this.Layout.Posters(), this.GetFaqPage(isPreview)]
  }

  // Private Methods

  private async _getAppInfo(): Promise<AppInfoModel> {
    return await axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: '/app-info',
      params: PopulationParam,
    }).then((resp) => this._convertCase(resp.data))
  }

  private async _getPageById(id: number, isPreview?: boolean): Promise<AxiosResponse> {
    if (isPreview) {
      return axios({
        method: HTTPMethod.GET,
        baseURL: Env.ApiUrl,
        url: `/pages/${id}`,
        params: { ...PopulationParam, publicationState: 'preview' },
      })
    }
    return axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: `/pages/${id}`,
      params: PopulationParam,
    })
  }

  private async _getPageIdFromSlug(slug: string, isPreview?: boolean): Promise<number> {
    if (isPreview) {
      return axios({
        method: HTTPMethod.GET,
        baseURL: Env.ApiUrl,
        url: `/pages?filters[Slug][$eq]=${slug}`,
        params: { publicationState: 'preview' },
      }).then((resp) => resp.data['data'][0]['id'])
    }

    return axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: `/pages?filters[Slug][$eq]=${slug}`,
    }).then((resp) => resp.data['data'][0]['id'])
  }

  private _convertCase<T extends object>(input: T) {
    return Converters.KeysConvert.ToLowerCase(input)
  }

  private _getIndexPageSlug(config: AppInfoModel) {
    return config.data.attributes.indexPageSlug
  }
}

export const PagePromise = new PagePromiseClass(LayoutPromise)
